import React from 'react';
import Icon from '../../components/Icon/Icon';
import { P } from '../../components/Text/Text';

import styles from './styles.module.scss';

const WaitForEncodingPopupBody = () => {
    return (
        <div className={styles.body}>
            <Icon name='exclamation'/>
            <P>Before approving the campaign, you must wait for the encoding of the files to be completed and verify their integrity.</P>
        </div>
    );
};

export default WaitForEncodingPopupBody;